<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("referralCode", 2) }}</div>
        <div class="section-subTitle my-2">{{ $t("referralCode_dash_msg") }}</div>
      </div>

      <div>
        <b-button variant="default" to="edit-referral-code" class="btn-blue">
          {{ $tc("add") }}
        </b-button>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-model="searchValue"
          v-debounce:500="getReferralCodeList"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>

      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class="mx-2">
          <b-dropdown
            :text="filterButtonTitle"
            class="ml-auto mr-3 filter-dropdown"
            variant="dropdown-curve"
          >
            <b-dropdown-item
              v-for="(status, statusIndex) in statuses"
              :key="statusIndex"
              v-on:click="filterStatus(status.status)"
            >{{ status.status }}
            </b-dropdown-item
            >
          </b-dropdown>

          <b-dropdown id="listview" name="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
            >{{ list.name }}
            </b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <table v-if="listView" class="list-view-table">
      <thead>
      <tr>
        <th> {{ 'Name' }} </th>
        <th>{{ $t("Code") }}</th>
        <th>{{ 'Redeemed' }}</th>
        <th>{{ 'Redeemer Customer' }}</th>
        <th>{{ 'Issuer Customer' }}</th>

        <th class="text-right">
          <span class="pr-3">{{ $tc("status", 2) }}</span>
        </th>
      </tr>
      </thead>

      <template v-if="ReferralCode && ReferralCode.length > 0">
        <tr v-for="(item, key) in ReferralCode" :key="key">
          <td>{{ $tc(item.name, 1) }}</td>
          <td>{{ item.code || "-" }}</td>

          <td>
            <StatusDot
              :status="item.is_used == 'N' ? 'active' : 'inactive'"
            />
          </td>

          <td>{{ item.redeemer_cust_email || "-" }}</td>
          <td>{{ item.issuer_cust_email || "-" }}</td>

          <td>
            <div class="d-flex align-items-center justify-content-end">
              <StatusDot
                :status="item.is_active == 'Y' ? 'active' : 'inactive'"
              />

              <b-dropdown class="ml-4" right variant="edit">
                <b-dropdown-item
                  @click="goToRoute('/master/edit-referral-code', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </template>

      <tbody v-if="ReferralCode.length == 0">
      <tr>
        <td colspan="3">
          <NoRecords/>
        </td>
      </tr>
      </tbody>
    </table>

    <b-pagination
      v-if="ReferralCode.length > 0"
      v-model="currentPage"
      :per-page="perPage"
      :total-rows="rows"
      aria-controls="my-table"
      @change="onChangePagination($event)"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import draggable from "vuedraggable";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
    draggable
  },
  data() {
    return {
      perPage: 10,
      isEditable: false,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      filterButtonTitle: "Active",
      statuses: [
        {status: "Active"},
        {status: "Inactive"},
        {status: "All"}
      ],
      selectedStatus: "Active",
      gridView: false,
      listView: true,
      ReferralCode: [],
      viewingnumbers: [],
      customErrors: {
        message: ""
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
      searchKey: "name"
    };
  },
  beforeMount() {
    this.getReferralCodeList();
    this.getviewingnumber();
  },
  methods: {
    draggableElements: function () {
      return this.isEditable;
    },
    filterStatus: function (status) {
      this.filterButtonTitle = status;
      this.selectedStatus = status;
      this.isEditable = false;
      this.getReferralCodeList();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        {name: "All", id: 1},
        {name: "10", id: 2},
        {name: "20", id: 3},
        {name: "30", id: 3},
        {name: "40", id: 4},
        {name: "50", id: 5}
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getReferralCodeList();
      } else {
        this.currentPage = event;
        this.getReferralCodeList();
      }
    },
    goToRoute: function (path, item) {
      const {r_id} = item;
      this.$router.push({
        path: path,
        query: {
          id: r_id
        }
      });
    },
    getReferralCodeList: function () {
      this.ReferralCode = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchKey: this.searchKey,
        searchValue: this.searchValue,
        orderBy: this.orderby,
        columnName: this.columnName,
        status: this.selectedStatus
      };

      MasterService.getAllReferralCode(payload)
      .then(response => {
        const {data} = response;
        if (data.status) {
          if (data.Records.length > 0) {
            this.ReferralCode = data.Records;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            console.log("Error:", data.message);
            this.$toasted.show(data.message);
          }
        } else {
          // Show Errors
          console.log("show error :", data.message);
        }
      })
      .catch(error => {
        // Show Catch Error
        console.log("show error :", error);
      });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ReferralCodeComponents/listCode.vue